var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 6.1722C17.8801 7.54307 19.6494 9.05984 21.2914 10.7084C22.94 12.3505 24.4568 14.1198 25.8277 15.9999M15.9999 6.1722C14.1198 7.54307 12.3505 9.05984 10.7084 10.7084C9.05984 12.3505 7.54307 14.1198 6.1722 15.9999M15.9999 6.1722C21.6524 2.08086 26.9994 0.54503 29.2271 2.77278C31.4549 5.00053 29.919 10.3474 25.8277 15.9999M25.8277 15.9999C29.919 21.6524 31.4549 26.9994 29.2271 29.2271C27.5757 30.8785 24.2079 30.4621 20.2749 28.4671M25.8277 15.9999C24.4568 17.8801 22.94 19.6494 21.2914 21.2914C19.6494 22.94 17.8801 24.4568 15.9999 25.8277M6.1722 15.9999C7.54307 17.8801 9.05984 19.6494 10.7084 21.2914C12.3505 22.94 14.1198 24.4568 15.9999 25.8277M6.1722 15.9999C2.08086 21.6524 0.54503 26.9994 2.77278 29.2271C5.00053 31.4549 10.3474 29.919 15.9999 25.8277M6.1722 15.9999C2.08245 10.3474 0.546614 5.00053 2.77278 2.77278C4.4242 1.12136 7.79195 1.53778 11.7249 3.53278",
    stroke: "#25A249",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 19.1666C17.7491 19.1666 19.1668 17.7488 19.1668 15.9999C19.1668 14.251 17.7491 12.8333 16.0002 12.8333C14.2513 12.8333 12.8335 14.251 12.8335 15.9999C12.8335 17.7488 14.2513 19.1666 16.0002 19.1666Z",
    stroke: "#25A249",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysics);
export default __webpack_public_path__ + "static/media/physics.f94cc06f1e90d591d5e3f41fbca6f6e6.svg";
export { ForwardRef as ReactComponent };